module.exports = __webpack_public_path__ + "static/img/inform.704769a8.png";